<template>
  <div v-if="this.step != undefined" class="flex flex-row gap-1 justify-between items-center content-center w-full">
    <span class="mdn-Icon-solar-visao-360 mdn-Icon--md text-red-500"></span>
    <mdn-text v-if="showTitle('DADOS_PESSOAIS')" class="text-sm text-red-500">Dados pessoais</mdn-text>
    <div class="flex border-b-2 w-full h-full" v-bind:class="{ 'border-red-500': showTitle('PAGAMENTO') || showTitle('SMS') }"></div>
    <span class="mdn-Icon-mensagem-sms mdn-Icon--md text-gray-300" v-bind:class="{ 'text-red-500': showTitle('PAGAMENTO') || showTitle('SMS') }"></span>
    <mdn-text v-if="showTitle('SMS')" class="text-sm text-red-500">Verificação</mdn-text>
    <div class="flex border-b-2 w-full h-full" v-bind:class="{ 'border-red-500': showTitle('PAGAMENTO') }"></div>
    <span class="mdn-Icon-cartao-de-credito mdn-Icon--md text-gray-300" v-bind:class="{ 'text-red-500': showTitle('PAGAMENTO') }"></span>
    <mdn-text v-if="showTitle('PAGAMENTO')" class="text-sm text-red-500">Pagamento</mdn-text>
  </div>
</template>

<script>
import { MdnText } from 'mondrian-vue'

export default {
  name: 'SellStepper',
  components: {
    MdnText
  },
  props: {
    step: String
  },
  methods: {
    showTitle (titleStep) {
      return titleStep === this.step
    }
  }
}
</script>
